import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'

export const LessonsPage: TOC<unknown> = <template>
  <div class="grow space-y-6">
    {{outlet}}
  </div>
</template>

export default RouteTemplate(LessonsPage)
